import { AUDIO_FILE } from '@shoflo/polymer';
import { logProgramChange } from '@shoflo/studio-redux/utils';
import { sceneBuilder } from '@studio/program/sceneBuilder/sceneBuilder';
import setProgram from './setProgram';
import setSceneLayout from './setSceneLayout';
import { SINGLE } from 'constants/SceneLayouts';
import { attachAudioPresenterSources } from 'utils/broadcastSourceHelper';

/**
 * Take a source as an argument, build a scene, and then set it as the program state
 */
export default source => {
  return (dispatch, getState) => {
    const {
      sceneLayers,
      banners,
      attendeeMuteStatus,
      broadcastSources: { sources },
      brandingSettings
    } = getState();
    const liveAudioSource = sources.filter(
      source => source.type === AUDIO_FILE && !source.hidden
    );
    const newSources = [source];
    if (liveAudioSource.length) {
      newSources.push(...liveAudioSource);
    }
    const combinedLayers = [...sceneLayers, ...banners];
    const withAudioPresenterSources = attachAudioPresenterSources(
      newSources,
      attendeeMuteStatus
    );
    const scene = sceneBuilder(
      SINGLE,
      withAudioPresenterSources,
      combinedLayers,
      {},
      {},
      brandingSettings?.fonts
    );

    dispatch(setProgram(scene));
    logProgramChange(getState, 'setSingleSourceProgram action');
    dispatch(setSceneLayout(SINGLE));
  };
};
